export const BackgroundEffects = () => {
	return (
		<div className="pointer-events-none fixed inset-0 overflow-hidden">
			{/* Gradient background animado */}
			<div className="bg-gradient-background absolute inset-0"></div>

			{/* Orbs gigantes em movimento constante */}
			<div className="bg-success/8 absolute -left-32 -top-32 h-96 w-96 animate-[orbit_20s_linear_infinite] rounded-full opacity-60 blur-3xl"></div>
			<div className="bg-primary-glow/8 absolute -right-16 -top-16 h-80 w-80 animate-[orbit_25s_linear_infinite_reverse] rounded-full opacity-50 blur-3xl"></div>
			<div className="bg-success-glow/10 absolute -bottom-24 left-1/4 h-72 w-72 animate-[orbit_18s_linear_infinite] rounded-full opacity-45 blur-3xl"></div>
			<div className="w-88 h-88 bg-success/6 absolute -bottom-32 -right-32 animate-[orbit_22s_linear_infinite_reverse] rounded-full opacity-40 blur-3xl"></div>

			{/* Ondas em movimento */}
			<div className="absolute inset-0 opacity-20">
				<div className="absolute left-0 top-0 h-full w-full animate-[wave_8s_ease-in-out_infinite] bg-[radial-gradient(ellipse_at_top_left,hsl(142_76%_36%_/_0.3),transparent_50%)]"></div>
				<div
					className="absolute right-0 top-0 h-full w-full animate-[wave_12s_ease-in-out_infinite_reverse] bg-[radial-gradient(ellipse_at_top_right,hsl(142_76%_50%_/_0.2),transparent_50%)]"
					style={{ animationDelay: "2s" }}
				></div>
				<div
					className="absolute bottom-0 left-0 h-full w-full animate-[wave_10s_ease-in-out_infinite] bg-[radial-gradient(ellipse_at_bottom_left,hsl(142_86%_45%_/_0.25),transparent_50%)]"
					style={{ animationDelay: "4s" }}
				></div>
			</div>

			{/* Partículas flutuantes intensas */}
			{Array.from({ length: 60 }).map((_, i) => {
				const size = Math.random() * 4 + 1;
				const duration = 4 + Math.random() * 8;
				return (
					<div
						key={i}
						className="bg-success-glow/40 animate-[float-particle_${duration}s_ease-in-out_infinite] absolute rounded-full"
						style={{
							width: `${size}px`,
							height: `${size}px`,
							left: `${Math.random() * 100}%`,
							top: `${Math.random() * 100}%`,
							animationDelay: `${Math.random() * 10}s`,
							animationDuration: `${duration}s`,
						}}
					></div>
				);
			})}

			{/* Linhas de energia em movimento */}
			<div className="left-1/6 via-success/30 absolute top-0 h-full w-px animate-[energy-line_6s_ease-in-out_infinite] bg-gradient-to-b from-transparent to-transparent opacity-60"></div>
			<div
				className="left-2/6 via-success-glow/25 absolute top-0 h-full w-px animate-[energy-line_8s_ease-in-out_infinite] bg-gradient-to-b from-transparent to-transparent opacity-50"
				style={{ animationDelay: "1s" }}
			></div>
			<div
				className="left-4/6 via-success/20 absolute top-0 h-full w-px animate-[energy-line_7s_ease-in-out_infinite] bg-gradient-to-b from-transparent to-transparent opacity-45"
				style={{ animationDelay: "3s" }}
			></div>
			<div
				className="left-5/6 via-success-glow/30 absolute top-0 h-full w-px animate-[energy-line_9s_ease-in-out_infinite] bg-gradient-to-b from-transparent to-transparent opacity-55"
				style={{ animationDelay: "2s" }}
			></div>

			{/* Formas geométricas flutuantes */}
			<div className="border-success/40 absolute left-1/3 top-1/4 h-8 w-8 rotate-45 animate-[geometric-float_12s_ease-in-out_infinite] border-2 opacity-60"></div>
			<div
				className="border-success-glow/50 absolute bottom-1/3 right-1/4 h-6 w-6 animate-[geometric-float_15s_ease-in-out_infinite] rounded-full border-2 opacity-50"
				style={{ animationDelay: "3s" }}
			></div>
			<div
				className="border-success/35 absolute left-1/4 top-2/3 h-10 w-10 animate-[geometric-float_10s_ease-in-out_infinite] border-2 opacity-45"
				style={{ animationDelay: "6s" }}
			></div>

			{/* Grid dinâmico */}
			<div className="absolute inset-0 animate-[grid-pulse_4s_ease-in-out_infinite] bg-[radial-gradient(hsl(142_76%_36%_/_0.15)_1px,transparent_1px)] opacity-30 [background-size:80px_80px]"></div>

			{/* Gradientes diagonais em movimento */}
			<div className="from-success/8 to-success-glow/6 absolute inset-0 animate-[diagonal-move_16s_ease-in-out_infinite] bg-gradient-to-tr via-transparent opacity-50"></div>
			<div
				className="via-success/5 absolute inset-0 animate-[diagonal-move_20s_ease-in-out_infinite_reverse] bg-gradient-to-bl from-transparent to-transparent opacity-40"
				style={{ animationDelay: "4s" }}
			></div>

			{/* Camada de brilho ambiente */}
			<div className="absolute inset-0 animate-[ambient-glow_8s_ease-in-out_infinite] bg-[radial-gradient(circle_at_center,hsl(142_76%_36%_/_0.1),transparent_70%)] opacity-60"></div>
		</div>
	);
};
